// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* EntryExitReasons Page Styles */
.entryExitReasons-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Catalog/EntryExitReasons/EntryExitReasons.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB","sourcesContent":["/* EntryExitReasons Page Styles */\n.entryExitReasons-container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
